// removed by extract-text-webpack-plugin
module.exports = {"sel_box_Li":"_3L-vhHwl6VQN-2BZjy0vOw","hud":"_32Cp2suXWDVA1qPMCSt2XZ","hudt":"_2nLvAGCro21qJu2qoTNEfh","hudt_ta":"_1MvenPHiVwXDvNDjZ1J_fu","hudi":"_1RX6wZENgkk2fjcU-Hfb_i","huds":"_3QqhdjuL9mMd126H27XNO1","hudd":"VoGekJFsQmZg77H33m_cZ","hudd_shu":"_3YoQilGEAMj5feHszWOooj","hudd_tx":"_2ch7qI60rmXeGJ41MiX38D","hudd_img":"_1reKlJktoFf7DVBbtpQ_h8","float":"_2yq7_AnqnLBWhFIzDhtZTV","mr0":"_28vCDzogE_NK1TmOoQVhzV","w420":"pabNISaTGCC70renrJHDm","hong":"_3aXuIet4uObl6DvPZRMfRU","hon":"_1aqHJp5BJlFiZOpYitCVab","hongd":"_3TGlUdN6qW629sJC_rVE7m","hond":"_1akm_0L_vQmHC60qUi64mG"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/BeautifulItemInfo/BeautifulItemInfo.scss
 ** module id = 954
 ** module chunks = 0
 **/